import React from 'react';

import get from 'lodash/get';
import { useFormState, useForm } from 'react-final-form';

import { Box } from '@vk-hr-tek/ui/Box';
import { useInject } from '@vk-hr-tek/core/ioc';
import { InputTooltip } from '@vk-hr-tek/ui/InputTooltip';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { CheckboxInput, TextInput } from '@vk-hr-tek/app-ui/form';

import { FormDto } from '../../../../dto';

const MIN_TEXT_VALUE = 1;
const MAX_TEXT_VALUE = 5000;

interface TextAnswerProps {
  name: string;
}

export const TextAnswer = ({ name }: TextAnswerProps) => {
  const form = useForm();
  const { values } = useFormState<FormDto>({
    subscription: {
      values: true,
    },
  });

  const validator = useInject(ValidationService);

  const isTextLimit = !!get(values, `${name}.answer.textLimit`, false);

  return (
    <Box display="flex" flexDirection="column" gap="16">
      <Box>
        <CheckboxInput
          name={`${name}.answer.textLimit`}
          label="Ограничение в символах"
          tooltip={
            <InputTooltip
              placement="top"
              description="Сейчас в текстовый ответ можно ввести до 5 000 символов. Вы можете добавить свое ограничение для ввода текста ответа"
            />
          }
          onChange={(value: boolean) => {
            form.change(`${name}.answer.textLimit`, value);

            if (!value) {
              form.change(`${name}.answer.minLength`, undefined);
              form.resetFieldState(`${name}.answer.minLength`);
              form.change(`${name}.answer.maxLength`, undefined);
              form.resetFieldState(`${name}.answer.maxLength`);
            }
          }}
        />
      </Box>

      {isTextLimit && (
        <Box display="flex" flexDirection="column">
          <TextInput
            required
            type="number"
            name={`${name}.answer.minLength`}
            placeholder="Введите число"
            label="Минимальное количество символов"
            debounceTimeout={200}
            validateArray={[
              validator.required('Обязательное поле'),
              validator.minValue(
                MIN_TEXT_VALUE,
                'Значение не может быть нулевым',
              ),
              validator.maxValue(
                MAX_TEXT_VALUE,
                'Значение не может превышать 5000',
              ),
              validator.maxValueWithConnectedFieldValidator(
                'Значение не может превышать максимальное количество символов',
                { field: `${name}.answer.maxLength` },
              ),
            ]}
          />

          <TextInput
            required
            type="number"
            name={`${name}.answer.maxLength`}
            placeholder="Введите число"
            label="Максимальное количество символов"
            debounceTimeout={200}
            validateArray={[
              validator.required('Обязательное поле'),
              validator.minValue(
                MIN_TEXT_VALUE,
                'Значение не может быть нулевым',
              ),
              validator.maxValue(
                MAX_TEXT_VALUE,
                'Значение не может превышать 5000',
              ),
            ]}
          />
        </Box>
      )}
    </Box>
  );
};
